// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__198A6","header":"MessagesList_header__2VEEo","chat":"MessagesList_chat__1UorM"};